import { login } from "../auth/oidc";

export function Login() {
  return (
    <main className="login-screen">
      <section className="login-panel">
        <div>
          <p className="eyebrow">EvoBuddy tenant portal</p>
          <h1>Run your business agents from one secure workspace.</h1>
          <p className="login-copy">
            Sign in with your EvoBuddy account to open tenant-scoped sessions, review messages,
            and hand work to your automation team.
          </p>
        </div>
        <div className="login-actions">
          <button type="button" onClick={() => void login()}>
            Continue with EvoBuddy
          </button>
          <p>Authorization uses the production OIDC provider and signed tenant claims.</p>
        </div>
      </section>
    </main>
  );
}
